import { handleError } from "core/utils/HandleError"
import { handleResponse } from "core/utils/HandleResponse"
import { AuthHttpClient } from "core/utils/HttpClient"

export function getParams(paramType: string) {
  return AuthHttpClient
    .get(`/admin/params?param=${paramType}`)
    .then(handleResponse)
    .catch(handleError)
}
export function getCountries() {
  return AuthHttpClient
    .get(`/admin/country`)
    .then(handleResponse)
    .catch(handleError)
}